<template>
  <div class="login-form">

    <div class="align-right" style="position: absolute; right: 0; top: 0; padding: 1rem;">
      <v-icon style="cursor:pointer" @click.prevent="$store.commit('closeLoginDialog')">close</v-icon>
    </div>

    <div class="login-form-container">

      <div style="margin: 1em 0 1em;">
        <div><img :src="require('../assets/pfx-logo-black.png')" class="center" style="width:100px;"/></div>
        <div>Real Estate Auction Platform</div>
      </div>

      <!-- LOGIN -->
      <div class="login" v-if="view === 'login'" :key="view">
        <h1>Welcome back</h1>
        <form ref="loginForm">
          <fieldset>
            <input type="email" id="email" autocomplete="username" placeholder="Enter Email Address" v-model.trim="email" @keyup.enter="login" required />
          </fieldset>
          <fieldset>
            <input type="password" id="password" autocomplete="current-password" placeholder="Password" v-model.trim="password" @keyup.enter="login" required minlength="8" />
            <div style="text-align: left;" v-if="errorMsg" class="error-message"><v-icon size="small" color="formerror">error</v-icon> {{ errorMsg }}</div>
          </fieldset>
          <fieldset>
            <button class="wide" @click.prevent="login">Login</button>
            <div style="text-align: left; font-size: 12px; margin-top: .5em; font-weight: 600;">Lost your password? <a @click="changeView('emailForPasswordChange')">Reset it</a></div>
          </fieldset>
        </form>

        <div class="clearfix" style="margin: 1rem 0 1.5rem; color: #b4b4b4;">
          <div class="col13"><hr size="1"/></div>
          <div class="col13" style="line-height: 4px; color: #9b9b9b; font-size: 12px;">OR LOGIN WITH</div>
          <div class="col13"><hr size="1"/></div>
        </div>

        <div style="margin-bottom: 1rem;">
          <div class="some-button">
            <a @click.prevent="loginWithFederation('Facebook')"><img :src="require('../assets/facebook-icon.png')" /></a>
          </div>
          <div class="some-button">
            <a @click.prevent="loginWithFederation('Google')"><img :src="require('../assets/google-icon.png')" /></a>
          </div>
        </div>

        <div>
          <div style="font-weight: 600;">Need an account? <a @click="changeView('signup')">Sign Up here</a></div>
        </div>
      </div>

      <!-- AFTER LOGIN -->
      <div class="after-login" v-if="view === 'after-login'" :key="view">
        <p>Processing login, please wait...</p>
      </div>

      <!-- REQUEST PASSWORD CHANGE -->
      <div class="change-password-email" v-if="view === 'emailForPasswordChange'" :key="view">
        <h1>Forgot Password?</h1>
        <form ref="requestPasswordChangeForm">
          <fieldset>
            <input type="email" autocomplete="username" placeholder="Email Address" v-model.trim="email" @keyup.enter="requestPasswordChange" required />
          </fieldset>
          <p>
            Please provide the email address you used to create account. We will send an email with the instructions
            how to reset the password.
          </p>
          <p class="error-message">{{ errorMsg }}</p>
          <fieldset>
            <button class="wide" @click.prevent="requestPasswordChange">Submit</button>
          </fieldset>
        </form>
        <a @click="changeView('login')">Cancel</a>
      </div>

      <!-- CHANGE PASSWORD -->
      <div class="change-password" v-if="view === 'changePassword'" :key="view">
        <form ref="changePasswordForm">
          <fieldset>
            <input type="text" id="changePasswordForm.token" autocomplete="off" placeholder="Token" v-model.trim="secret" @keyup.enter="changePassword" required minlength="6" />
          </fieldset>
          <fieldset>
            <input type="password" autocomplete="new-password" placeholder="New Password" title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}" v-model.trim="newPassword" @keyup.enter="changePassword" required minlength="8" />
          </fieldset>
          <p>
            Check your email inbox. We've just sent you a token to verify your email address. Please provide that token,
            along with a new password of your choice.
          </p>
          <p class="error-message">{{ errorMsg }}</p>
          <fieldset>
            <button class="wide" @click.prevent="changePassword">Verify Token</button>
          </fieldset>
        </form>
      </div>

      <!-- REGISTER -->
      <div class="signup" v-if="view === 'signup'" :key="view">
        <h1>Join the platform</h1>
        <form ref="registerForm">
          <fieldset>
            <input type="email" autocomplete="username" placeholder="Enter Email Address" v-model.trim="email" @keyup.enter="register" required />
          </fieldset>
          <fieldset>
            <input type="password" autocomplete="new-password" title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}" placeholder="Password" v-model.trim="password" @keyup.enter="register" required minlength="8" />
          </fieldset>
          <fieldset>
            <input type="password" autocomplete="new-password" title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}" placeholder="Re-enter Password" v-model.trim="reenter" @keyup.enter="register" required minlength="8" />
          </fieldset>
          <p>
            <input id="accept" type="checkbox" required />
            <label for="accept" style="font-size: 12px;">
              I agree to the
              <a @click.prevent="$store.dispatch('openTermsAndConditionsPopup')">Terms of Service</a>,
              <a @click.prevent="$store.dispatch('openBrokerRegistrationPopup')">Broker Registration Terms</a> and the
              <a @click.prevent="$store.dispatch('openPrivacyPolicyPopup')">Privacy Policy</a> of PFX Real Estate Auction Platform.
            </label>
          </p>
          <p class="error-message">{{ errorMsg }}</p>
          <fieldset>
            <button class="wide" @click.prevent="register">Sign Up</button>
          </fieldset>
        </form>

        <div class="clearfix" style="margin: 1.5rem 0; color: #b4b4b4;">
          <div class="col13"><hr size="1"/></div>
          <div class="col13" style="line-height: 4px; color: #9b9b9b; font-size: 12px;">OR SIGN UP WITH</div>
          <div class="col13"><hr size="1"/></div>
        </div>

        <div style="margin: 0 0 1rem;">
          <div class="some-button">
            <a @click.prevent="loginWithFederation('Facebook')"><img :src="require('../assets/facebook-icon.png')" /></a>
          </div>
          <div class="some-button">
            <a @click.prevent="loginWithFederation('Google')"><img :src="require('../assets/google-icon.png')" /></a>
          </div>
        </div>

        <p>Already have an account? <a @click="changeView('login')">Login here</a></p>
        <p>Already have a token? <a @click="changeView('secret')">Verify</a></p>
      </div>

      <div class="secret" v-if="view === 'secret'" :key="view">
        <form ref="submitSecretForm">
          <p>Please check your email inbox. There should be a new message from us.</p>
          <p>Write the token from the email to the field below, and then click the "Verify token" button.</p>
          <p>After successful verification, we will redirect you to the login page.</p>
          <fieldset>
            <input type="text" id="submitSecretForm.token" autocomplete="off" placeholder="Token" v-model.trim="secret" @keyup.enter="submitSecret" required minlength="6" />
          </fieldset>
          <p v-if="errorMsg" class="error-message">{{ errorMsg }}</p>
          <fieldset>
            <button class="wide" @click.prevent="submitSecret">Verify Token</button>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { CognitoUser } from 'amazon-cognito-identity-js'
  import { cognitoSignUp, submitConfirmationToken, processLogin } from '../utils/PfxCognitoFunctions.js'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import { currentDate } from '../utils/PfxUtils.js'


  const appConfig = process.env.config
  const COGNITO_CLIENT_ID = appConfig.cognito.ClientId
  const COGNITO_AUTH_API = appConfig.cognito.authorizeApi
  const COGNITO_AUTH_CALLBACK = appConfig.cognito.authorizeCallback

  export default {
    name: 'Login',
    data() {
      return {
        email: '',
        password: '',
        reenter: '',
        secret: this.$route.params.token || '',
        errorMsg: '',
        view: this.$route.meta.view || 'login',
        newPassword: ''
      }
    },
    computed: {
      ...mapGetters([
        'userPool',
        'cognitoStorage'
      ]),
      loginDialogVisibleUpdated() {
        return this.$store.state.loginDialog.visible
      }
    },
    watch: {
      loginDialogVisibleUpdated(visible) {
        if (visible === true) { // if login dialog is opened (but not closed) then switch to 1st view
          console.log('opening login dialog')
          const view = this.$store.state.loginDialog.view || 'login'
          this.password = ''
          this.changeView(view)
        }
        if (visible === false) {
          console.log('closing login dialog')
          this.password = ''
        }
      }
    },
    methods: {
      changeView(view) {
        this.errorMsg = ''
        this.reenter = ''
        this.newPassword = ''
        this.secret = ''
        this.view = view
      },

      requestPasswordChange() {
        if (!this.$refs.requestPasswordChangeForm.checkValidity()) {
          this.$refs.requestPasswordChangeForm.reportValidity()
          return
        }

        let that = this
        const userData = {
          Username: this.email,
          Pool: this.userPool,
          Storage: this.cognitoStorage
        }
        that.errorMsg = ''
        that.$store.commit('setLoadingSpinner', true)
        const user = new CognitoUser(userData)
        user.forgotPassword({
          onSuccess: function(data) {
            // successfully initiated reset password request
            console.log('forgotPassword data', JSON.stringify(data))
            that.changeView('changePassword')
            that.$store.commit('setLoadingSpinner', false)
          },
          onFailure: function(err) {
            console.error('forgotPassword err', JSON.stringify(err))
            const code = err.code || ''
            if (code === 'LimitExceededException') {
              that.errorMsg = 'Too many attemps lately for this email address. Please retry after some time.'
            } else if (code === 'UserNotFoundException') {
              that.errorMsg = 'User not found, please confirm your email address and try again.'
            } else {
              that.errorMsg = 'Unexpected error occurred.'
            }
            that.$store.commit('setLoadingSpinner', false)
          }
        })
      },

      changePassword() {
        if (!this.$refs.changePasswordForm.checkValidity()) {
          this.$refs.changePasswordForm.reportValidity()
          return
        }

        let that = this
        that.errorMsg = ''
        that.$store.commit('setLoadingSpinner', true)
        const userData = {
          Username: this.email,
          Pool: this.userPool,
          Storage: this.cognitoStorage
        }
        const user = new CognitoUser(userData)
        user.confirmPassword(this.secret, this.newPassword, {
          onSuccess() {
            console.log('confirmPassword success')
            that.changeView('login')
            that.$notify({ type: 'info', message: 'Your password was successfully reset. Please try login again.' })
            that.$store.commit('setLoadingSpinner', false)
          },
          onFailure(err) {
            console.error('confirmPassword err', JSON.stringify(err))
            const code = err.code || ''
            if (code === 'CodeMismatchException') {
              that.errorMsg = 'The provided token was either invalid or already used.'
            } else if (code === 'ExpiredCodeException') {
              that.errorMsg = 'The provided token was expired. Please request a new one.'
            } else {
              that.errorMsg = 'Validation failed'
            }
            that.$store.commit('setLoadingSpinner', false)
          }
        })
      },

      loginWithFederation(identityProvider) {
        const url = COGNITO_AUTH_API +
          '?response_type=token' +
          '&client_id=' + encodeURI(COGNITO_CLIENT_ID) +
          '&identity_provider=' + encodeURI(identityProvider) +
          '&redirect_uri=' + encodeURI(COGNITO_AUTH_CALLBACK) +
          '&state=' + encodeURI(document.origin) +
          '&scope=profile+email+openid'

        const self = this
        const w = window.open(url, 'pfxFederatedLoginPopup', 'width=640,height=640,menubar=no,toolbar=no,location=no,status=no')
        window.addEventListener('message', (e) => {
          if (e.data.messageId === 'pfxFederatedIdToken') {
            console.log('pfxFederatedIdToken message received', e.data)
            const error = e.data.error
            const idToken = e.data.idToken
            const accessToken = e.data.accessToken
            if (error) {
              self.errorMsg = 'Error during authentication'
            } else {
              self.$store.commit('setLoadingSpinner', true)
              self.$store.dispatch('authorizeFromFederated', { idToken, accessToken, federated: true, router: this.$router, closeLoginDialogAfter: true, noActionsAfterLogin: false })
              self.changeView('after-login')
            }
            w.close()
          }
        })
      },

      login() {
        if (!this.$refs.loginForm.checkValidity()) {
          this.$refs.loginForm.reportValidity()
          return
        }
        this.processLogin()
      },

      processLogin() {
        const that = this
        that.$store.commit('setLoadingSpinner', true)
        processLogin(this.userPool, this.cognitoStorage, this.email, this.password)
          .then(view => {
            if (view === 'after-login') {
              // update lastLogin
              const curDate = currentDate()
              const userID = this.userPool.getCurrentUser().getUsername()
              Vue.PfxBackendApi.postUser({ id: userID, lastLogin: curDate })
              .then(res => {
                console.log('lastLogin updated res', res)
              }).catch(err => {
                console.error('lastLogin updated err', err)
              })
              that.$store.dispatch('authorize', { router: that.$router, closeLoginDialogAfter: true, doTenantRedirect: true })
              that.changeView('after-login')
            } else if (view === 'secret') {
              that.changeView('secret')
              that.$store.commit('setLoadingSpinner', false)
            } else {
              console.error('unexpected return view from processLogin [%s]', view)
              that.$store.commit('setLoadingSpinner', false)
            }
          })
          .catch(errorMsg => {
            that.errorMsg = errorMsg
            that.$store.commit('setLoadingSpinner', false)
          })
      },

      submitSecret() {
        if (!this.$refs.submitSecretForm.checkValidity()) {
          this.$refs.submitSecretForm.reportValidity()
          return
        }

        const that = this
        that.errorMsg = ''
        that.$store.commit('setLoadingSpinner', true)
        submitConfirmationToken(this.userPool, this.cognitoStorage, this.email, this.secret)
          .then(() => {
            that.changeView('login')
            that.processLogin()
          })
          .catch(errorMsg => that.errorMsg = errorMsg)
          .then(() => that.$store.commit('setLoadingSpinner', false))
      },

      register() {
        if (!this.$refs.registerForm.checkValidity()) {
          this.$refs.registerForm.reportValidity()
          return
        }
        if (this.password !== this.reenter) {
          this.errorMsg = 'Passwords do not match.'
          return
        }

        this.$store.commit('setLoadingSpinner', true)
        cognitoSignUp(this.userPool, this.cognitoStorage, this.email, this.password)
          .then(() => this.changeView('secret'))
          .catch(errorMsg => {
            console.log('catched error from cognitoSignUp [%s]', errorMsg)
            this.errorMsg = errorMsg
          })
          .then(() => this.$store.commit('setLoadingSpinner', false))
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .col19 { @include column(1/9); }
  .col49 { @include column(4/9); }
  .col13 { @include column(1/3); }

  .login-form {
    text-align: center;
    position: relative;
  }

  .login-form-container {
    padding: 1rem 0 1rem;
    @include center($max-width: 350px)
  }

  h1 {
    font-family: 'Encode Sans', sans-serif;
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 1em;
    margin: 0 0 1em;
  }

  .some-button {
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue